let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("d4o6y")).then(() => parcelRequire('dOwnI'));